import { Redirect, Route, Switch, useHistory } from "react-router-dom";
import TextProvider from "../providers/TextProvider";
import Checkout from "./Checkout";

const Store = () => {
  const history = useHistory();
  return (
    <Switch>
      <Route path="/store/:sku">
        <Checkout onBack={() => history.goBack()} />
      </Route>
      <Route path="/store">
        <Redirect to={"/store/MA1"} />
      </Route>
    </Switch>
  );
};

const StoreWrapper = () => (
  <TextProvider type="store">
    <Store />
  </TextProvider>
);

export default StoreWrapper;
